import {
  FETCH_DATA_COMMONS_REQUEST,
  FETCH_DATA_COMMONS_SUCCESS,
  FETCH_DATA_COMMONS_FAILURE,
} from "../../actions/commons/get-commons-actions";

const initialState = {
  list: [],
  isLoading: false,
  error: null,
  meta: null,
};

const CommonsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_DATA_COMMONS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_DATA_COMMONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload.values,
        meta: action.payload.meta,
      };
    case FETCH_DATA_COMMONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default CommonsReducer;
